export default __webpack_public_path__ + "static/media/aboutUsTitleMobile.11594017.jpg";